module.exports = __webpack_public_path__ + "media/images/ui__boxBg-f836db0191d294a67cb2abe03e6c5036.jpg";